import React from 'react'
import { Chart } from 'primereact/chart'

function ColumnChart({ data, animate = true }) {

    const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        animation: animate,
        plugins: {
            legend: {
                labels: {
                    fontColor: "#363535"
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: "#363535",
                    font: {
                        weight: 500
                    }
                },
                grid: {
                    display: false,
                    drawBorder: false
                }
            },
            y: {
                ticks: {
                    color: "#363535"
                },
                grid: {
                    color: "#EBEDED",
                    drawBorder: false
                }
            }
        }
    }

    return (
        <Chart type="bar" data={data} options={options} style={{ height: '450px' }} />
    )
}

export default React.memo(ColumnChart)
